import { useI18n } from 'hooks/useI18n';
import Applications from './Applications';
import {
  StyledBillboard,
  StyledBillboardContent,
  StyledBillboardTitle,
  StyledContainer
} from './Candidates.styled';
import Conversions from './Conversions';

const Candidates: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  return (
    <div>
      <StyledBillboard>
        <StyledContainer>
          <StyledBillboardContent>
            <StyledBillboardTitle as="p">
              {t('state-of-hiring.candidates.billboard-title')}
            </StyledBillboardTitle>
            <p>{t('state-of-hiring.candidates.billboard-desc')}</p>
          </StyledBillboardContent>
        </StyledContainer>
      </StyledBillboard>
      <Conversions />
      <Applications />
    </div>
  );
};

export default Candidates;
